import { MOBILE_WIDTH } from '../constants/breakpoints';

export const isMobile = (width: number, maxWidth?: number) => {
  return maxWidth ? width <= maxWidth : width <= MOBILE_WIDTH;
};
